import { render, staticRenderFns } from "./AdminEvents.vue?vue&type=template&id=b7aa2fe6&scoped=true"
import script from "./AdminEvents.vue?vue&type=script&lang=js"
export * from "./AdminEvents.vue?vue&type=script&lang=js"
import style0 from "./AdminEvents.vue?vue&type=style&index=0&id=b7aa2fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7aa2fe6",
  null
  
)

export default component.exports